import { createIcon } from '@chakra-ui/react';

export const SocialInstagram = createIcon({
  displayName: `SocialInstagram`,
  viewBox: `0 0 33 33`,
  path: (
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3px"
      transform="translate(-1.5 -1.5)"
    >
      <path d="M10.5 3h15a7.5 7.5 0 0 1 7.5 7.5v15a7.5 7.5 0 0 1-7.5 7.5h-15A7.5 7.5 0 0 1 3 25.5v-15A7.5 7.5 0 0 1 10.5 3z" />
      <path d="M24 17.055A6 6 0 1 1 18.945 12 6 6 0 0 1 24 17.055z" />
    </g>
  ),
});
